import { useQuery } from "@apollo/client/react";
import { GuestPendingSignUpDocument } from "@repo/graphql/documents/guest/query.generated";
import { useMemo } from "react";

/**
 * The email sign-up this browser made whose link is still unopened, read from the
 * backend (the session cookie is the state, so a reload simply asks again). `pending`
 * is null when there is none; `resendAt` is when a new link can be sent (epoch ms).
 * `loading` is true only until the first answer.
 *
 * `skip` leaves the question unasked: the sign-up only matters when there is no guest
 * campaign left.
 */
const useGuestPendingSignUp = (skip = false) => {
  const { data, loading } = useQuery(GuestPendingSignUpDocument, {
    skip,
    fetchPolicy: "cache-and-network",
  });
  const pending = useMemo(() => {
    const signUp = data?.guest.pendingSignUp;
    if (!signUp) return null;
    return {
      email: signUp.email,
      resendAt: new Date(signUp.resendAt).getTime(),
    };
  }, [data]);
  return { pending, loading: loading && !data };
};

export default useGuestPendingSignUp;
